import axios from "axios";

export const getBlueprintContent = async () => {
  try {
    const response = await axios.get("/blueprint");
    return response.data;
  } catch (error) {
    console.error("Error fetching blueprint content:", error);
    throw error;
  }
};

export const getBlueprintContentByType = async (type) => {
  try {
    const response = await axios.get(`/blueprint/type/${type}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching blueprint content by type:", error);
    throw error;
  }
};

export const getBlueprintContentById = async (uuid) => {
  try {
    const response = await axios.get(`/blueprint/${uuid}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching blueprint content by id:", error);
    throw error;
  }
};

